import hyperdom from 'hyperdom'
import TourHeader from '../tourHeader.jsx'

export default class TourHeaderDayTour extends TourHeader {
  constructor (options) {
    super(options)
    this.quoteCriteria = options.quoteCriteria
  }


  renderRegularLayout () {
    const {details} = this
    return <div class="tour-header-confirmation">
      <div class="tour-header-confirmation__details-section">
        <div class="tour-header-confirmation__header u-padding-medium">
          <div class="tour-header-confirmation__image">{this.renderHeaderImage(details.imageUrl, true)}</div>
          <div class="tour-header-confirmation__departure-info u-margin-left-large">
            <h3 class='tour-header__name u-margin-bottom-small'>{details.tourName}</h3>
            <div class='tour-header__middle-info'>
              {this.renderProductRating()}
            </div>
            <div className="tour_header_pickup-location">
              <span className='tour_header_pickup-location__header'>Pickup Location: </span>
              <span className='tour_header_pickup-location__content'>{this.quoteCriteria.pickupLocation.associatedProductName}</span>
            </div>
          </div>
        </div>
        <div class="tour-header-confirmation__details u-padding-left-medium  u-padding-bottom-small">
          {this.renderDetail('days')}
          {this.renderDetail('countries')}
          {this.renderDetail('passengers')}
        </div>
      </div>
      <div class="tour-header__map">{this.renderHeaderImage(details.mapUrl)}</div>
    </div>
  }

  renderSmallDeviceLayout () {
    const {details} = this
    return <div class="tour-header-confirmation">
      <div class="tour-header-confirmation__image">{this.renderHeaderImage(details.imageUrl)}</div>
      <div
        class="tour-header-confirmation__details-section u-padding-left-medium u-padding-right-medium u-padding-bottom-large u-padding-top-large">
        <div class="tour-header-confirmation__title">{details.tourName}</div>
        <div >{this.renderProductRating()}</div>
        <div className="tour_header_pickup-location">
          <span className='tour_header_pickup-location__header'>Pickup Location: </span>
          <span
            className='tour_header_pickup-location__content'>{this.quoteCriteria.pickupLocation.associatedProductName}</span>
        </div>
        <div class="tour-header-confirmation__details-row">
          {this.renderDetail('days')}
          {this.renderDetail('countries')}
          {this.renderDetail('passengers')}
        </div>
      </div>
      <div class="tour-header__map">{this.renderHeaderImage(details.mapUrl)}</div>
    </div>
  }

  render (mode) {
    this.details = this.getDetails()
    return mode === 'compact' ? this.renderCompact() : this.renderNormal()
  }
}
